import React from "react";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {Button, Card} from "reactstrap";
import {useTranslation} from "react-i18next";

import waLogo from '../../../../assets/utils/images/messenger/wa.png';


const ConnectCardWABA = (
    {
        activeShop,
    }
) => {
    const {t, i18n} = useTranslation();


    return <Card className="mb-3 profile-responsive">
        <div className="dropdown-menu-header text-dark">
            <div className="dropdown-menu-header-inner bg-white">
                <div className="menu-header-content btn-pane-right d-block text-center">
                    <h5 className="d-flex align-items-center justify-content-center mb-3">
                        <img src={waLogo} alt="WhatsApp Business API" style={{height: 30}} className='mr-2'/>
                        WhatsApp Business API
                    </h5>
                    <h6 className='opacity-6 my-4'>
                        {t('connect_cards.waba.caption', 'Send broadcasts, enjoy buttons and be protected from blocking with official WhatsApp Business API profile')}
                    </h6>
                    <div className="menu-header-btn-pane">
                        <Link  to={`/${activeShop.id}/connect/waba`}>
                            <Button color="primary">
                                {t('connect_bot.common.submit', 'Connect')}
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </Card>;
};


const mapStateToProps = state => ({
    activeShop: state.Shops.activeShop,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectCardWABA);
